// removed by extract-text-webpack-plugin
module.exports = {"item":"_8IzD-_OMRZA_Tytb9Q72R"};


//////////////////
// WEBPACK FOOTER
// ./src/components/imagesSlider/style.scss
// module id = 193
// module chunks = 0